import { studioMachine, cameraMachine, splatMachine } from '@ad3d/state-machine';
import { StudioContext } from '../../contexts/studio.context';
import { SuperSplatCanvas } from './supersplat-canvas';
import { EditorLayout } from '../../layouts/editor-layout';
import { createBrowserInspector } from '@statelyai/inspect';

const isInspect = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('inspect');

if (isInspect) {
    console.log('[Studio] Inspector enabled. If the popup does not appear, check your popup blocker.');
}

const inspector = isInspect
    ? createBrowserInspector({
        autoStart: true
    }) 
    : undefined;

export interface StudioProps {
    sceneId: string;
    userId: string;
    actors: {
        prepareSceneActor: any;
        loadSplatActor: any;
    };
}

export function Studio({ sceneId, userId, actors }: StudioProps) {
    return (
        <StudioContext.Provider 
            logic={studioMachine.provide({
                actors: {
                    ...actors,
                    cameraMachine,
                    splatMachine: splatMachine.provide({
                        actors: {
                            loadSplatActor: actors.loadSplatActor
                        }
                    })
                }
            })}
            options={{
                input: {
                    sceneId,
                    userId,
                    userRole: 'viewer'
                },
                inspect: inspector?.inspect
            }}
        >
            <div className="relative h-screen w-full overflow-hidden">
                <SuperSplatCanvas />
                <div className="absolute inset-0 z-10 pointer-events-none">
                    <EditorLayout />
                </div>
            </div>
        </StudioContext.Provider>
    );
}
